'use client';

import { createContext, ReactNode } from 'react';
import { useContextBroker } from '../ContextBroker/useContextBroker';

export type FlagsContextValue = {
  [key: string]: boolean | string;
};

export type FlagsBrokeredValue = {
  value: FlagsContextValue;
};

export const FlagsContext = createContext<FlagsBrokeredValue>({
  value: {}
});

type FlagsProviderProps = {
  children: ReactNode;
};

function FlagsProvider(props: FlagsProviderProps) {
  const { children } = props;
  const brokerValue = useContextBroker();

  const decoratedValue: FlagsBrokeredValue = {
    value: brokerValue.flags
  };

  return (
    <FlagsContext.Provider value={decoratedValue}>
      {children}
    </FlagsContext.Provider>
  );
}

export default FlagsProvider;
